import styled from 'styled-components';
import { FormControl } from '@material-ui/core';

export const FormControlStyled = styled(FormControl)`
	&& {
	}
`;
